import { useCallback } from "react";
import { useSchool } from "../contexts/SchoolContext";
import { useCampus } from "../contexts/CampusContext";
import { handleSchoolId } from "../utils/helpers";

/**
 * Reads the globally selected school/campus (from the header scope filter) and
 * exposes the selected ids plus a helper to client-side filter any list of
 * entities that carry `school_id` / `campus_id`. When nothing is selected the
 * helper is a no-op, so the default view shows all data.
 */
export function useScopeFilter() {
  const { selectedSchool } = useSchool();
  const { selectedCampus } = useCampus();

  const schoolId = selectedSchool?._id;
  const campusId = selectedCampus?._id;

  const filterByScope = useCallback(
    <T,>(items: T[]): T[] => {
      if (!schoolId && !campusId) return items;
      return items.filter((item) => {
        const it = item as {
          school_id?: string | { _id: string } | null;
          campus_id?: string | { _id: string } | null;
        };
        const schoolMatch = schoolId
          ? handleSchoolId(it.school_id) === schoolId
          : true;
        const campusMatch = campusId
          ? handleSchoolId(it.campus_id) === campusId
          : true;
        return schoolMatch && campusMatch;
      });
    },
    [schoolId, campusId]
  );

  return {
    schoolId,
    campusId,
    hasScope: Boolean(schoolId || campusId),
    filterByScope,
  };
}
